'use strict';

window.addEventListener('DOMContentLoaded', () => {


})
